import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import HedenLogo from "../assets/logo-section/heden.png";
import MsaLogo from "../assets/logo-section/msa.png";
import BorusanLogo from "../assets/logo-section/borusan.png";
import FibabankaLogo from "../assets/logo-section/fibabanka.png";
import OpetLogo from "../assets/logo-section/opet.png";
import KolektifHouseLogo from "../assets/logo-section/kolektif-house.png";
import CiLogo from "../assets/logo-section/ci.png";
import RostiLogo from "../assets/logo-section/rosti.png";
import MorogluLogo from "../assets/logo-section/moroglu.png";
import GuvenLogo from "../assets/logo-section/guven.png";
import SancakliLogo from "../assets/logo-section/sancakli.png";
import MelezLogo from "../assets/logo-section/melez.png";
import OdeLogo from "../assets/logo-section/ode.png";
import MidasLogo from "../assets/logo-section/midas.png";
import PetraLogo from "../assets/logo-section/petra.png";
import NtrLogo from "../assets/logo-section/nmr.png";
import NobelLogo from "../assets/logo-section/nobel.png";
import TofasLogo from "../assets/logo-section/tofas.png";
import SiedresLogo from "../assets/logo-section/siedres.png";
import KoppertLogo from "../assets/logo-section/koppert.png";
import YapasLogo from "../assets/logo-section/yapas.png";
import OzpolatLogo from "../assets/logo-section/ozpolat.png";
import MLogo from "../assets/logo-section/m-logo.png";
import DuranLogo from "../assets/logo-section/duran-dogan.png";
import EmekLogo from "../assets/logo-section/emek.png";
import GalatawindLogo from "../assets/logo-section/galatawind.png";
import MarkalabLogo from "../assets/collaboration/markalab.png";
import RemaxLogo from "../assets/collaboration/remax.png";
import languageStorage from "../lang/findLanguage";

export default function LogoSection({ language }) {
  const images = [
    {
      id: 1,
      src: HedenLogo,
    },
    {
      id: 2,
      src: MsaLogo,
    },
    {
      id: 3,
      src: BorusanLogo,
    },
    {
      id: 4,
      src: FibabankaLogo,
    },
    {
      id: 5,
      src: KolektifHouseLogo,
    },
    {
      id: 6,
      src: CiLogo,
    },
    {
      id: 7,
      src: RostiLogo,
    },
    {
      id: 8,
      src: MorogluLogo,
    },
    {
      id: 9,
      src: GuvenLogo,
    },
    {
      id: 10,
      src: SancakliLogo,
    },
    {
      id: 11,
      src: MelezLogo,
    },
    {
      id: 12,
      src: OdeLogo,
    },
    {
      id: 13,
      src: MidasLogo,
    },
    {
      id: 14,
      src: PetraLogo,
    },
    {
      id: 15,
      src: NtrLogo,
    },
    {
      id: 16,
      src: NobelLogo,
    },
    {
      id: 17,
      src: TofasLogo,
    },
    {
      id: 18,
      src: SiedresLogo,
    },
    {
      id: 19,
      src: KoppertLogo,
    },
    {
      id: 20,
      src: YapasLogo,
    },
    {
      id: 21,
      src: OzpolatLogo,
    },
    {
      id: 22,
      src: MLogo,
    },
    {
      id: 23,
      src: DuranLogo,
    },
    {
      id: 24,
      src: EmekLogo,
    },
    {
      id: 25,
      src: GalatawindLogo,
    },
    {
      id: 26,
      src: OpetLogo,
    },
    {
      id: 27,
      src: MarkalabLogo,
    },
    {
      id: 28,
      src: RemaxLogo,
    },
  ];
  return (
    <section
      className='logo-section'
      id={
        languageStorage() === "tr"
          ? language[0].sections[11].keys[1].k0002
          : language[1].sections[11].keys[1].k0002
      }
    >
      <h3>
        {languageStorage() === "tr"
          ? language[0].sections[3].keys[0].k0001
          : language[1].sections[3].keys[0].k0001}
      </h3>
      <p>
        {languageStorage() === "tr"
          ? language[0].sections[3].keys[1].k0002
          : language[1].sections[3].keys[1].k0002}
      </p>
      <div className='logo d-flex flex-wrap align-items-center justify-content-center'>
        {images.map((item) => (
          <LazyLoadImage
            key={item.id}
            alt=''
            height={46}
            src={item.src}
            width={106}
          />
        ))}
      </div>
    </section>
  );
}
